import React from 'react';
import Skeleton from '@mui/material/Skeleton';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import './tablePlaceholder.scss';

interface TablePlaceholderProps {
    numColumns: number;
    singlePlaceholder?: boolean;
    numRows?: number;
    rowClassName?: string;
}

const TablePlaceholder = ({
    numColumns,
    singlePlaceholder = false,
    numRows = 35,
    rowClassName = '',
}: TablePlaceholderProps) => {
    const RowPlaceholder = ({
        children,
    }: {
        children: React.ReactNode;
    }): JSX.Element => {
        if (singlePlaceholder)
            return <TableCell colSpan={numColumns}>{children}</TableCell>;
        const cellsList = Array.from(Array(numColumns).keys());
        return (
            <>
                {cellsList.map(cell => (
                    <TableCell key={cell}>{children}</TableCell>
                ))}
            </>
        );
    };

    const rowList = Array.from(Array(numRows).keys());

    return (
        <>
            {rowList.map(row => (
                <TableRow key={row} className={rowClassName}>
                    <RowPlaceholder>
                        <Skeleton animation='wave' variant='text' />
                    </RowPlaceholder>
                </TableRow>
            ))}
        </>
    );
};

export default TablePlaceholder;
